import { CheckCircle2, XCircle, AlertCircle, Loader2, Activity } from "lucide-react";
import { Badge } from "../ui/badge";

function statusColor(healthy, configured) {
  if (!configured) return { icon: AlertCircle, cls: "text-slate-400", bg: "bg-slate-100 text-slate-500", label: "N\u00e3o configurado" };
  if (healthy) return { icon: CheckCircle2, cls: "text-emerald-600", bg: "bg-emerald-100 text-emerald-700", label: "OK" };
  return { icon: XCircle, cls: "text-red-500", bg: "bg-red-100 text-red-700", label: "Falhou" };
}

function relTime(iso) {
  if (!iso) return null;
  try {
    const d = new Date(iso);
    const diff = Date.now() - d.getTime();
    const s = Math.floor(diff / 1000);
    if (s < 60) return `h\u00e1 ${s}s`;
    if (s < 3600) return `h\u00e1 ${Math.floor(s / 60)} min`;
    if (s < 86400) return `h\u00e1 ${Math.floor(s / 3600)} h`;
    return `h\u00e1 ${Math.floor(s / 86400)} dias`;
  } catch { return null; }
}

export function AdminIntegrationHealthCard({ integ, loading, testId }) {
  const s = statusColor(integ.healthy, integ.configured);
  const Icon = loading ? Loader2 : s.icon;
  return (
    <div data-testid={testId} className="bg-white rounded-xl border border-black/5 p-4">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="font-heading font-bold tracking-tighter text-slate-900 truncate">{integ.label}</p>
          <p className="text-[11px] text-slate-500 mt-0.5">{integ.provider}</p>
        </div>
        <Icon className={`w-5 h-5 shrink-0 ${loading ? "animate-spin text-slate-400" : s.cls}`} />
      </div>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        <Badge className={`${s.bg} hover:${s.bg} text-[10px]`}>{s.label}</Badge>
        {integ.latency_ms > 0 && (
          <span className="text-[11px] text-slate-400 flex items-center gap-1"><Activity className="w-3 h-3" />{integ.latency_ms} ms</span>
        )}
      </div>
      <p className="text-xs text-slate-500 mt-2 line-clamp-2" title={integ.message}>{integ.message}</p>
      {integ.last_used_at && (
        <p className="text-[11px] text-slate-400 mt-2">Ultima utiliza\u00e7\u00e3o: {relTime(integ.last_used_at)}</p>
      )}
      {integ.extra && Object.keys(integ.extra).some((k) => integ.extra[k] != null) && (
        <div className="mt-2 flex flex-wrap gap-2">
          {Object.entries(integ.extra).filter(([, v]) => v != null).map(([k, v]) => (
            <span key={k} className="text-[10px] uppercase tracking-wider font-semibold text-slate-500 bg-slate-50 rounded px-1.5 py-0.5">
              {k.replace(/_/g, " ")}: {String(v)}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
